import { apiPost } from '../api'

export const issue_ved_days = data => {
  return apiPost({
    endpoint: 'attendance/issue_ved_days',
    data: data
  })
}
